import { getClass, getSubclass } from './contentRegistry';

// Resolve a class (and optional subclass) at a given level into the
// character-shaped slice it contributes.
//
// Phase 2.5 supports level 1 + 2 + 3 (the levels our 2 archetypes touch).
// Higher-level computation works generically since the JSON declares
// features for the levels the SRD covers. Bugs surface only when an
// archetype steps past a level whose features haven't been declared.

export const applyClass = ({ classId, subclassId = null, level = 1 }) => {
  const cls = getClass(classId);
  if (!cls) return null;

  const subclass = subclassId ? getSubclass(subclassId) : null;

  const featuresGained = [];
  for (const feat of cls.features || []) {
    if (feat.level <= level) featuresGained.push({ ...feat, source: cls.name });
  }
  if (subclass) {
    for (const feat of subclass.features || []) {
      if (feat.level <= level) featuresGained.push({ ...feat, source: subclass.name });
    }
  }

  return {
    classId: cls.id,
    className: cls.name,
    subclassId: subclass?.id || null,
    subclassName: subclass?.name || null,
    level,
    hitDie: cls.hitDie,
    primaryAbility: cls.primaryAbility || [],
    savingThrows: cls.savingThrows || [],
    proficiencies: cls.proficiencies || {},
    spellcasting: cls.spellcasting || null,
    features: featuresGained,
    // Class level grants its own skill choice budget; the archetype declares
    // which skills were picked. We pass it through for downstream consumers.
    skillChoices: {
      count: cls.proficiencies?.skills?.choose || 0,
      from: cls.proficiencies?.skills?.from || [],
    },
  };
};
